const RELOAD_MARKER = 'sp_stale_chunk_reload_at';
const RELOAD_COOLDOWN_MS = 60_000;

function readMarker(): number {
  try {
    return Number(sessionStorage.getItem(RELOAD_MARKER)) || 0;
  } catch {
    return 0;
  }
}

function writeMarker(at: number): void {
  try {
    sessionStorage.setItem(RELOAD_MARKER, String(at));
  } catch {
    // private browsing / storage disabled — the cooldown degrades to "no reload"
  }
}

/**
 * A chunk URL that 404s is rewritten to index.html by the CloudFront SPA fallback,
 * so the tab is holding a build whose assets no longer exist. Reloading picks up
 * the current index.html. The cooldown stops a genuine outage becoming a reload loop.
 */
export function reloadForStaleChunk(): boolean {
  const now = Date.now();
  if (now - readMarker() < RELOAD_COOLDOWN_MS) return false;
  writeMarker(now);
  window.location.reload();
  return true;
}

export function installStaleChunkRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForStaleChunk()) event.preventDefault();
  });
}
